import { useTheme } from "../../themeContext";
import "./SettingBody.css";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Avatar from "@mui/material/Avatar";
import { TbSettingsPlus } from "react-icons/tb";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import Switch from "@mui/material/Switch";
import AvTimerOutlinedIcon from "@mui/icons-material/AvTimerOutlined";
import CoffeeOutlinedIcon from "@mui/icons-material/CoffeeOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { PiBuildingOfficeFill } from "react-icons/pi";
import { MdOutlineCastForEducation, MdAccessTime } from "react-icons/md"; // ← added MdAccessTime
import { TbReceiptRupee } from "react-icons/tb";
import { FaUserSecret } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { BiSolidUserPin } from "react-icons/bi";
import { VscFeedback } from "react-icons/vsc";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { RiUserShared2Line } from "react-icons/ri";
import { MdLightMode, MdDarkMode } from 'react-icons/md';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { commonGetData } from "../../redux/slices/commonSlice";
import { useEffect, useCallback, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { dropdownFunc } from "../../services/commonServices";
import { getCalendarMonthListPath } from "../../services/config";
import Widgets from "../../components/Widgets";
import SettingCards from "../../components/card/SettingCards";
import { HasPermission } from "../../services/hasPermission";
// import {}


const SettingBody = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : [];
  const [accessModules, setAccessModules] = useState([]);
  useEffect(() => {
    const splitArray = user.accessModules.split(",");
    setAccessModules(splitArray);
  }, []);

  return (
    <div className="SettingBody">
      <div className="SettingBody-card color-white">
        <Row>
          <Col sm="6" className="mb-3">
            <Row>
              <Col sm="12" className="mb-3">
                <CompanyDetails />
              </Col>
              <Col sm="12" className="mb-3">
                <MyTeam />
              </Col>
            </Row>
          </Col>
          {/* -------------------------- */}
          <Col sm="6" className="mb-3">
            <Row>
              <Col sm="12" className="mb-3">
                {(accessModules.includes("17") ||
                  accessModules.includes("18") ||
                  accessModules.includes("19") ||
                  accessModules.includes("20") ||
                  accessModules.includes("21")) && <AttendanceSettings />}
              </Col>
              <Col sm="12" className="mb-3">
                <AlertNotifications />
              </Col>
              <Col sm="12" className="mb-3">
                <OtherSettings />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const CompanyDetails = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : [];
  const [accessModules, setAccessModules] = useState([]);
  useEffect(() => {
    const splitArray = user.accessModules.split(",");
    setAccessModules(splitArray);
  }, []);

  return (
    <Widgets
      body={
        <>
          <h3 className="color-white mb-3">Company Details</h3>
          <SettingCards
            icon={<Avatar alt="Remy Sharp" src={user.company_logo ? user.company_logo : "/static/images/avatar/1.jpg"} />}
            title={user.company_name}
            subtitle={"Edit Company Details"}
            button={
              <Link to={"/company-details"}>
                <ArrowForwardIcon className="btn-arrow" />
              </Link>
            }
          />
          {accessModules.includes("10") && (
            <SettingCards
              icon={<HiOutlineLocationMarker sx={{ scale: 1.1 }} />}
              title={"My Branches"}
              subtitle={"Add or remove branches"}
              button={
                <Link to={"/company_branches"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}
          {accessModules.includes("11") && (
            <SettingCards
              icon={<PiBuildingOfficeFill sx={{ scale: 1.1 }} />}
              title={"My Departments"}
              subtitle={"Add or remove Departments"}
              button={
                <Link to={"/company-departments"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}
          {accessModules.includes("12") && (
            <SettingCards
              icon={<MdOutlineCastForEducation sx={{ scale: 1.1 }} />}
              title={"My Designation"}
              subtitle={"Add or remove Designation"}
              button={
                <Link to={"/company-designation"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}
          {accessModules.includes("14") && (
            <SettingCards
              icon={<BiSolidUserPin sx={{ scale: 1.1 }} />}
              title={"My Employee Id"}
              subtitle={"Add or remove Employee Id"}
              button={
                <Link to={"/my-employee-id"}>
                  <ArrowForwardIcon className="btn-Roles" />
                </Link>
              }
            />
          )}
        </>
      }
    />
  );
};

const MyTeam = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : [];
  const [accessModules, setAccessModules] = useState([]);
  useEffect(() => {
    const splitArray = user.accessModules.split(",");
    setAccessModules(splitArray);
  }, []);

  return (
    <Widgets
      body={
        <>
          <h3 className="color-white mb-3">My Team</h3>
          <SettingCards
            icon={<SummarizeOutlinedIcon sx={{ scale: 1.1 }} />}
            title={"Custom Fields"}
            subtitle={"Create Custom staff information fields"}
            button={null}
          />
          <SettingCards
            icon={<PeopleAltOutlinedIcon sx={{ scale: 1.1 }} />}
            title={"Today Check In List"}
            subtitle={"Current Date Employee Info"}
            button={
              <Link to={"/current-date-employee-info"}>
                <ArrowForwardIcon className="btn-arrow" />
              </Link>
            }
          />
          {/* New Card - Generate Payslip */}
          <SettingCards
            icon={<ReceiptOutlinedIcon sx={{ scale: 1.1 }} />}
            title={"Generate Payslip"}
            subtitle={"Create employee salary slips"}
            button={
              <Link to={"/generate-payslip"}>
                <ArrowForwardIcon className="btn-arrow" />
              </Link>
            }
          />
        </>
      }
    />
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// UPDATED: AttendanceSettings — Overtime Settings card added at the bottom
// ─────────────────────────────────────────────────────────────────────────────
const AttendanceSettings = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : [];
  const [accessModules, setAccessModules] = useState([]);
  useEffect(() => {
    const splitArray = user.accessModules.split(",");
    setAccessModules(splitArray);
  }, []);

  return (
    <Widgets
      body={
        <>
          <h3 className="color-white mb-3">Attendance Settings</h3>

          {accessModules.includes("17") && (
            <SettingCards
              icon={<AvTimerOutlinedIcon sx={{ scale: 1.1 }} />}
              title={"Shifts"}
              subtitle={"Add or remove company shifts"}
              button={
                <Link to={"/attendance-settings-shifts"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}

          {accessModules.includes("18") && (
            <SettingCards
              icon={<CoffeeOutlinedIcon sx={{ scale: 1.1 }} />}
              title={"Breaks"}
              subtitle={"Add or remove company Breaks"}
              button={
                <Link to={"/breaks"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}

          {accessModules.includes("19") && (
            <SettingCards
              icon={<CalendarMonthOutlinedIcon sx={{ scale: 1.1 }} />}
              title={"Holiday List"}
              subtitle={"Add remove public holiday for your company"}
              button={
                <Link to={"/holiday-module"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}

          {accessModules.includes("20") && (
            <SettingCards
              icon={<CalendarMonthOutlinedIcon sx={{ scale: 1.1 }} />}
              title={"Leave Settings"}
              subtitle={"Create custom company leaves"}
              button={
                <Link to={"/leave-module"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}

          {accessModules.includes("21") && (
            <SettingCards
              icon={
                <TbSettingsPlus
                  style={{ width: "25px", height: "25px" }}
                  sx={{ scale: 1 }}
                />
              }
              title={"Attendance Settings"}
              subtitle={"Create custom company Attendance"}
              button={
                <Link to={"/attendance-setting"}>
                  <ArrowForwardIcon className="btn-arrow" />
                </Link>
              }
            />
          )}

          {/* ── NEW: Overtime Settings ── */}
          <SettingCards
            icon={<MdAccessTime style={{ width: "22px", height: "22px" }} />}
            title={"Overtime Settings"}
            subtitle={"Configure overtime calculation and approval"}
            button={
              <Link to={"/overtime-settings"}>
                <ArrowForwardIcon className="btn-arrow" />
              </Link>
            }
          />
        </>
      }
    />
  );
};

const AlertNotifications = () => {
  return (
    <Widgets
      body={
        <>
          <h3 className="color-white mb-3">Alert Notifications</h3>
          <SettingCards
            icon={<NotificationsOutlinedIcon sx={{ scale: 1.1 }} />}
            title={"Alert Notifications"}
            subtitle={"Get important alerts on App"}
            button={<Switch inputProps={{ "aria-label": "controlled" }} />}
          />
        </>
      }
    />
  );
};

const OtherSettings = () => {
  const { theme, toggleTheme } = useTheme();
  const logOut = () => {
    localStorage.removeItem("auth");
    localStorage.removeItem("superadmin");
    localStorage.removeItem("userPermissions");
    localStorage.removeItem("user_data");
    localStorage.removeItem("employee-id");
    localStorage.clear();
    window.location.reload();
  };

  const [show, setShow] = useState(false);
  const [darkTheme, setDarkTheme] = useState(localStorage.getItem("theme") === "dark");

  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDarkTheme = () => {
    toggleTheme();
    setDarkTheme(!darkTheme);
  };

  const handleLogout = () => {
    logOut();
    handleModalClose();
  };

  return (
    <Widgets
      body={
        <>
          <Dialog
            open={show}
            onClose={handleModalClose}
            maxWidth="xs"
            fullWidth
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="dark-bg-color"
          >
            <DialogContent>
              <DialogContentText
                id="scroll-dialog-description"
                tabIndex={-1}
                style={{ position: "relative" }}
              >
                <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <RiUserShared2Line style={{ fontSize: "40px", color: "#fff" }} />
                  <h2 className="color-white">LOGOUT</h2>
                  <h3 className="color-white mb-3">
                    Are you sure! you want to logout?
                  </h3>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                    <button
                      style={{
                        width: "120px",
                        height: "35px",
                        fontSize: "15px",
                        border: "none",
                        borderRadius: "12px",
                      }}
                      className="universal-input-one"
                      onClick={handleModalClose}
                    >
                      No
                    </button>
                    <button
                      style={{
                        width: "120px",
                        height: "35px",
                        fontSize: "15px",
                      }}
                      className="universal-btn"
                      onClick={handleLogout}
                    >
                      Yes, I want
                    </button>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <h3 className="color-white mb-3">Other Settings</h3>

          <SettingCards
            icon={darkTheme ? <MdDarkMode sx={{ scale: 1.1 }} /> : <MdLightMode sx={{ scale: 1.1 }} />}
            title={"Dark Mode"}
            subtitle={"Switch between light and dark theme"}
            button={
              <div className="impressive-toggle-container">
                <input
                  type="checkbox"
                  id="theme-toggle"
                  className="impressive-toggle-input"
                  checked={darkTheme}
                  onChange={handleDarkTheme}
                  aria-label="Toggle dark mode"
                />
                <label htmlFor="theme-toggle" className="impressive-toggle-label">
                  <div className="impressive-toggle-track">
                    <div className="impressive-toggle-thumb">
                      <div className="impressive-toggle-icon">
                        {darkTheme ? (
                          <MdDarkMode className="toggle-icon-moon" />
                        ) : (
                          <MdLightMode className="toggle-icon-sun" />
                        )}
                      </div>
                    </div>
                    <div className="impressive-toggle-background">
                      <div className="impressive-toggle-stars">
                        <span className="star star-1">✦</span>
                        <span className="star star-2">✦</span>
                        <span className="star star-3">✦</span>
                        <span className="star star-4">✦</span>
                        <span className="star star-5">✦</span>
                      </div>
                      <div className="impressive-toggle-clouds">
                        <div className="cloud cloud-1"></div>
                        <div className="cloud cloud-2"></div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            }
          />

          <SettingCards
            icon={<VscFeedback sx={{ scale: 1.1 }} />}
            title={"Request A Feature"}
            subtitle={"Give your valuable feedback and feature request"}
            button={<Switch inputProps={{ "aria-label": "controlled" }} />}
          />

          <SettingCards
            icon={<LuLogOut sx={{ scale: 1.1 }} />}
            title={"Logout"}
            subtitle={"Logout from devices"}
            button={
              <button onClick={handleShow} className="universal-btn">
                Logout
              </button>
            }
          />
        </>
      }
    />
  );
};

const SettingCard = ({ icon, heading, subHeading, routPath, switchBtn, onClick }) => {
  return (
    <div
      className="SettingCard universal-bg-color color-white"
      onClick={onClick}
      style={{ cursor: heading === "Logout" ? "pointer" : "default" }}
    >
      <div className="SettingCard-item">
        <div className="SettingCard-icon">{icon}</div>
        <div className="SettingCard-body">
          <p>{heading}</p>
          <label>{subHeading}</label>
        </div>
        <div>{switchBtn || ""}</div>
      </div>
      {!switchBtn && switchBtn !== null && (
        <div className="SettingCard-Button">
          {switchBtn || onClick ? (
            <></>
          ) : (
            <Link to={routPath}>
              <ArrowForwardIcon className="btn-arrow" />
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

const SettingCardOne = ({ icon, heading, subHeading, routPath, switchBtn, onClick }) => {
  return (
    <div
      className="SettingCard"
      onClick={onClick}
      style={{ cursor: heading === "Logout" ? "pointer" : "default", width: "100%" }}
    >
      <div className="SettingCard-item">
        <div className="SettingCard-icon">{icon}</div>
        <div className="SettingCard-body">
          <p>{heading}</p>
          <label>{subHeading}</label>
        </div>
        <div>{switchBtn || ""}</div>
      </div>
      {!switchBtn && switchBtn !== null && (
        <div className="SettingCard-Button">
          {switchBtn || onClick ? (
            <></>
          ) : (
            <Link to={routPath}>
              <ArrowForwardIcon className="btn-arrow" />
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

const SettingBodyCard = ({ title, children }) => {
  return (
    <div className="SettingTitle-body">
      <p className="color-white">{title}</p>
      <div className="Setting-body-content">{children}</div>
    </div>
  );
};

export default SettingBody;